<template>
  <default-checkbox :value="assignPowerOfAttorney" v-on="$listeners">
    <div>
      <span>
      אני מאשר.ת לriseup לקבל מידע על קופות
      הגמל להשקעה שפתחתי דרכה ומנוהלות על ידי
      מיטב כמו שמפורט
      </span>
      <a @click.stop="openPowerOfAttorney">ביפויי כח</a>
    </div>
  </default-checkbox>
</template>

<script>
import DefaultCheckbox from '@/components/styled/DefaultCheckbox';

export default {
  name: 'AssignPowerOfAttorney',
  components: { DefaultCheckbox },
  props: {
    assignPowerOfAttorney: Boolean,
  },
  methods: {
    openPowerOfAttorney() {
      window.open('/pdfs/riseup_power_of_attorney.pdf', '_blank');
    },
  },
};
</script>

<style>
a {
  display: inline-block;
  text-decoration: underline;
  cursor: pointer;
}
</style>
